module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img0.c1311a27.png";